module.exports = __webpack_public_path__ + "img/GERENTE_Daniel_Penhos.3a8db72a.jpg";